var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex flex-column fill-height px-3" }, [
    _c(
      "div",
      {},
      [
        _c(
          "div",
          { staticClass: "d-flex align-center mb-3" },
          [
            _c("asset-image", {
              staticClass: "mr-2",
              attrs: {
                src: require("../../images/ai_navigator/ai_navigator_icon.svg"),
                width: "32",
              },
            }),
            _vm._v(" "),
            _c("h2", { staticClass: "oxygen" }, [_vm._v("AI Navigator")]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-center mb-2" },
          [
            _c("h4", { staticClass: "text-body-2 font-weight-medium" }, [
              _vm._v("Location / I-Codes"),
            ]),
            _vm._v(" "),
            _c(
              "v-tooltip",
              {
                attrs: { bottom: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              attrs: {
                                icon: "",
                                "aria-label":
                                  "Information about jurisdiction selection",
                              },
                            },
                            on
                          ),
                          [_c("v-icon", [_vm._v("mdi-information-outline")])],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              },
              [
                _vm._v(" "),
                _c("span", { staticClass: "tooltip-content" }, [
                  _vm._v('Select a US state or "I-Codes" for ICC model code'),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("navigator-location-selection"),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                staticClass: "grey lighten-4 my-3",
                attrs: { block: "", depressed: "", outlined: "" },
                on: { click: _vm.newChatClicked },
              },
              [
                _c("v-icon", { staticClass: "mr-1" }, [
                  _vm._v("mdi-message-outline"),
                ]),
                _vm._v("\n                New Question\n            "),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("navigator-sidebar-disclaimer-block"),
        _vm._v(" "),
        _c("v-divider", { staticClass: "my-4" }),
        _vm._v(" "),
        _c("h5", { staticClass: "text--secondary px-1" }, [
          _vm._v("Your History"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "overflow-auto mx-n3" },
      [
        _c(
          "v-list",
          { attrs: { dense: "" } },
          _vm._l(_vm.conversationGroups, function (item, i) {
            return _c(
              "v-list-item",
              {
                key: i,
                class: {
                  selected: _vm.isSelected(item),
                },
                attrs: { "two-line": "" },
                on: {
                  click: function ($event) {
                    return _vm.selectDate(item.createdAt)
                  },
                },
              },
              [
                _c(
                  "v-list-item-content",
                  [
                    _c(
                      "v-list-item-title",
                      { class: { "primary--text": _vm.isSelected(item) } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.formatDate(item.createdAt)) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item-subtitle",
                      {
                        staticClass: "pt-1",
                        class: { "primary--text": _vm.isSelected(item) },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.formatQuestionLabel(item.totalQuestions)
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }